// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Wallis & Futuna */
const WF = /^(?:(?:72|8[23])\d{4})$/;

export default WF;
